import React, { ReactNode, useState } from "react";
import SettingsIcon from "@mui/icons-material/Settings";
import { Box, IconButton, Popover, Tooltip } from "@mui/material";

export type SettingsButtonProps = {
  children: ReactNode;
  size?: "small" | "medium";
};

export function SettingsButton(props: SettingsButtonProps) {
  const { children, size = "small" } = props;
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <Tooltip title="Settings">
        <IconButton
          size={size}
          aria-label="Settings"
          aria-haspopup="dialog"
          aria-expanded={Boolean(anchorEl)}
          onClick={(event) => setAnchorEl(event.currentTarget)}
          sx={{
            color: "text.secondary",
            transition: "color 0.3s",
            "&:hover": { color: "primary.main" }
          }}
        >
          <SettingsIcon fontSize={size} />
        </IconButton>
      </Tooltip>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Box sx={{ p: 2, minWidth: 220 }}>{children}</Box>
      </Popover>
    </>
  );
}
